import React from 'react';
import IconButtonActions from '../../DataTable/IconButtonActions';
import { CustomColumn } from '../../../types/customColumn';
import clsx from 'clsx';

interface ModalBasicTableBodyProps {
  table: any;
  actions?: (row: any) => any[];
  noDataMessage?: string;
}

const ModalBasicTableBody: React.FC<ModalBasicTableBodyProps> = ({
  table,
  actions,
  noDataMessage,
}) => {
  const { getTableBodyProps, page, prepareRow, columns } = table;

  return (
    <tbody
      {...getTableBodyProps()}
      className="bg-[#F8FAFC] dark:bg-[#0F172A]" // 🔥 Fondo general del body
    >
      {page.length > 0 ? (
        page.map((row: any, rowIndex: number) => {
          prepareRow(row);
          return (
            <tr
              key={row.id || rowIndex}
              {...row.getRowProps()}
              className={clsx(
                // Alterna colores entre filas
                rowIndex % 2 === 0
                  ? 'bg-white dark:bg-boxdark'
                  : 'bg-[#F1F5F9] dark:bg-[#1E293B]',
                // Hover state
                'hover:bg-gray-50 dark:border-gray-700 border-b border-slate-200 transition-colors dark:hover:bg-graydark/40'
              )}
            >
              {row.cells.map((cell: any) => {
                const column = cell.column as CustomColumn<object>;
                return (
                  <td
                    {...cell.getCellProps()}
                    className="text-gray-700 dark:text-gray-200 px-4 py-3 text-sm"
                  >
                    {column.customCell
                      ? column.customCell(cell)
                      : cell.render('Cell')}
                  </td>
                );
              })}
              <td className="px-4 py-3 text-center">
                <div className="flex justify-center">
                  <IconButtonActions
                    actions={actions(row.original)}
                    row={row.original}
                  />
                </div>
              </td>
            </tr>
          );
        })
      ) : (
        // Fila cuando no hay datos
        <tr className="bg-white dark:bg-boxdark">
          <td
            colSpan={columns.length + (actions ? 1 : 0)}
            className="text-gray-500 dark:text-gray-400 px-4 py-6 text-center text-sm"
          >
            {noDataMessage || 'No hay datos disponibles.'}
          </td>
        </tr>
      )}
    </tbody>
  );
};

export default ModalBasicTableBody;
